import create from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

const useStore = create(
  subscribeWithSelector((set) => ({
    idle: false,
    play: 0,
    canPlay: false,
    currentPolly: {
      id: 3,
      name: "Feemale 1",
      online: false,
      polly: {
        viseme: [
          { time: 125, type: "viseme", value: "k" },
          { time: 237, type: "viseme", value: "a" },
          { time: 337, type: "viseme", value: "sil" },
          { time: 562, type: "viseme", value: "a" },
          { time: 812, type: "viseme", value: "p" },
          { time: 837, type: "viseme", value: "S" },
          { time: 937, type: "viseme", value: "o" },
          { time: 1037, type: "viseme", value: "a" },
          { time: 1137, type: "viseme", value: "t" },
          { time: 1200, type: "viseme", value: "@" },
          { time: 1462, type: "viseme", value: "sil" },
          { time: 1980, type: "viseme", value: "r" },
          { time: 2055, type: "viseme", value: "i" },
          { time: 2092, type: "viseme", value: "@" },
          { time: 2155, type: "viseme", value: "t" },
          { time: 2167, type: "viseme", value: "i" },
          { time: 2305, type: "viseme", value: "t" },
          { time: 2355, type: "viseme", value: "a" },
          { time: 2480, type: "viseme", value: "s" },
          { time: 2542, type: "viseme", value: "t" },
          { time: 2617, type: "viseme", value: "u" },
          { time: 2667, type: "viseme", value: "p" },
          { time: 2730, type: "viseme", value: "i" },
          { time: 2792, type: "viseme", value: "t" },
          { time: 2892, type: "viseme", value: "i" },
          { time: 2992, type: "viseme", value: "u" },
          { time: 3280, type: "viseme", value: "sil" },
          { time: 3810, type: "viseme", value: "a" },
          { time: 3860, type: "viseme", value: "p" },
          { time: 3922, type: "viseme", value: "k" },
          { time: 3985, type: "viseme", value: "i" },
          { time: 4047, type: "viseme", value: "r" },
          { time: 4172, type: "viseme", value: "t" },
          { time: 4247, type: "viseme", value: "u" },
          { time: 4310, type: "viseme", value: "t" },
          { time: 4422, type: "viseme", value: "i" },
          { time: 4485, type: "viseme", value: "S" },
          { time: 4560, type: "viseme", value: "i" },
          { time: 4610, type: "viseme", value: "u" },
          { time: 4710, type: "viseme", value: "O" },
          { time: 4810, type: "viseme", value: "t" },
          { time: 4922, type: "viseme", value: "@" },
          { time: 4985, type: "viseme", value: "p" },
          { time: 5047, type: "viseme", value: "a" },
          { time: 5110, type: "viseme", value: "t" },
          { time: 5235, type: "viseme", value: "t" },
          { time: 5297, type: "viseme", value: "i" },
          { time: 5310, type: "viseme", value: "S" },
          { time: 5422, type: "viseme", value: "i" },
          { time: 5435, type: "viseme", value: "t" },
          { time: 5510, type: "viseme", value: "t" },
          { time: 5610, type: "viseme", value: "k" },
          { time: 5635, type: "viseme", value: "i" },
          { time: 5760, type: "viseme", value: "u" },
          { time: 5797, type: "viseme", value: "p" },
          { time: 5860, type: "viseme", value: "@" },
          { time: 5935, type: "viseme", value: "t" },
          { time: 5985, type: "viseme", value: "s" },
          { time: 6060, type: "viseme", value: "@" },
          { time: 6110, type: "viseme", value: "t" },
          { time: 6122, type: "viseme", value: "t" },
          { time: 6235, type: "viseme", value: "s" },
          { time: 6297, type: "viseme", value: "i" },
          { time: 6310, type: "viseme", value: "t" },
          { time: 6360, type: "viseme", value: "T" },
          { time: 6497, type: "viseme", value: "E" },
          { time: 6560, type: "viseme", value: "t" },
          { time: 6622, type: "viseme", value: "i" },
          { time: 6672, type: "viseme", value: "k" },
          { time: 6797, type: "viseme", value: "p" },
          { time: 6822, type: "viseme", value: "i" },
          { time: 6885, type: "viseme", value: "t" },
          { time: 6985, type: "viseme", value: "i" },
          { time: 7060, type: "viseme", value: "@" },
          { time: 7260, type: "viseme", value: "sil" },
          { time: 7827, type: "viseme", value: "t" },
          { time: 7890, type: "viseme", value: "E" },
          { time: 7940, type: "viseme", value: "t" },
          { time: 8002, type: "viseme", value: "s" },
          { time: 8065, type: "viseme", value: "k" },
          { time: 8140, type: "viseme", value: "E" },
          { time: 8190, type: "viseme", value: "t" },
          { time: 8252, type: "viseme", value: "s" },
          { time: 8315, type: "viseme", value: "t" },
          { time: 8402, type: "viseme", value: "a" },
          { time: 8440, type: "viseme", value: "r" },
          { time: 8527, type: "viseme", value: "t" },
          { time: 8627, type: "viseme", value: "@" },
          { time: 8690, type: "viseme", value: "t" },
          { time: 8840, type: "viseme", value: "sil" },
        ],
        audioUrl: "audio/female-1.mp3",
      },
    },
    pollys: [
      {
        id: 3,
        name: "Feemale 1",
        online: false,
        polly: {
          viseme: [
            { time: 125, type: "viseme", value: "k" },
            { time: 237, type: "viseme", value: "a" },
            { time: 337, type: "viseme", value: "sil" },
            { time: 562, type: "viseme", value: "a" },
            { time: 812, type: "viseme", value: "p" },
            { time: 837, type: "viseme", value: "S" },
            { time: 937, type: "viseme", value: "o" },
            { time: 1037, type: "viseme", value: "a" },
            { time: 1137, type: "viseme", value: "t" },
            { time: 1200, type: "viseme", value: "@" },
            { time: 1462, type: "viseme", value: "sil" },
            { time: 1980, type: "viseme", value: "r" },
            { time: 2055, type: "viseme", value: "i" },
            { time: 2092, type: "viseme", value: "@" },
            { time: 2155, type: "viseme", value: "t" },
            { time: 2167, type: "viseme", value: "i" },
            { time: 2305, type: "viseme", value: "t" },
            { time: 2355, type: "viseme", value: "a" },
            { time: 2480, type: "viseme", value: "s" },
            { time: 2542, type: "viseme", value: "t" },
            { time: 2617, type: "viseme", value: "u" },
            { time: 2667, type: "viseme", value: "p" },
            { time: 2730, type: "viseme", value: "i" },
            { time: 2792, type: "viseme", value: "t" },
            { time: 2892, type: "viseme", value: "i" },
            { time: 2992, type: "viseme", value: "u" },
            { time: 3280, type: "viseme", value: "sil" },
            { time: 3810, type: "viseme", value: "a" },
            { time: 3860, type: "viseme", value: "p" },
            { time: 3922, type: "viseme", value: "k" },
            { time: 3985, type: "viseme", value: "i" },
            { time: 4047, type: "viseme", value: "r" },
            { time: 4172, type: "viseme", value: "t" },
            { time: 4247, type: "viseme", value: "u" },
            { time: 4310, type: "viseme", value: "t" },
            { time: 4422, type: "viseme", value: "i" },
            { time: 4485, type: "viseme", value: "S" },
            { time: 4560, type: "viseme", value: "i" },
            { time: 4610, type: "viseme", value: "u" },
            { time: 4710, type: "viseme", value: "O" },
            { time: 4810, type: "viseme", value: "t" },
            { time: 4922, type: "viseme", value: "@" },
            { time: 4985, type: "viseme", value: "p" },
            { time: 5047, type: "viseme", value: "a" },
            { time: 5110, type: "viseme", value: "t" },
            { time: 5235, type: "viseme", value: "t" },
            { time: 5297, type: "viseme", value: "i" },
            { time: 5310, type: "viseme", value: "S" },
            { time: 5422, type: "viseme", value: "i" },
            { time: 5435, type: "viseme", value: "t" },
            { time: 5510, type: "viseme", value: "t" },
            { time: 5610, type: "viseme", value: "k" },
            { time: 5635, type: "viseme", value: "i" },
            { time: 5760, type: "viseme", value: "u" },
            { time: 5797, type: "viseme", value: "p" },
            { time: 5860, type: "viseme", value: "@" },
            { time: 5935, type: "viseme", value: "t" },
            { time: 5985, type: "viseme", value: "s" },
            { time: 6060, type: "viseme", value: "@" },
            { time: 6110, type: "viseme", value: "t" },
            { time: 6122, type: "viseme", value: "t" },
            { time: 6235, type: "viseme", value: "s" },
            { time: 6297, type: "viseme", value: "i" },
            { time: 6310, type: "viseme", value: "t" },
            { time: 6360, type: "viseme", value: "T" },
            { time: 6497, type: "viseme", value: "E" },
            { time: 6560, type: "viseme", value: "t" },
            { time: 6622, type: "viseme", value: "i" },
            { time: 6672, type: "viseme", value: "k" },
            { time: 6797, type: "viseme", value: "p" },
            { time: 6822, type: "viseme", value: "i" },
            { time: 6885, type: "viseme", value: "t" },
            { time: 6985, type: "viseme", value: "i" },
            { time: 7060, type: "viseme", value: "@" },
            { time: 7260, type: "viseme", value: "sil" },
            { time: 7827, type: "viseme", value: "t" },
            { time: 7890, type: "viseme", value: "E" },
            { time: 7940, type: "viseme", value: "t" },
            { time: 8002, type: "viseme", value: "s" },
            { time: 8065, type: "viseme", value: "k" },
            { time: 8140, type: "viseme", value: "E" },
            { time: 8190, type: "viseme", value: "t" },
            { time: 8252, type: "viseme", value: "s" },
            { time: 8315, type: "viseme", value: "t" },
            { time: 8402, type: "viseme", value: "a" },
            { time: 8440, type: "viseme", value: "r" },
            { time: 8527, type: "viseme", value: "t" },
            { time: 8627, type: "viseme", value: "@" },
            { time: 8690, type: "viseme", value: "t" },
            { time: 8840, type: "viseme", value: "sil" },
          ],
          audioUrl: "audio/female-1.mp3",
        },
      },
      {
        id: 4,
        name: "Feemale 2",
        online: false,
        polly: {
          viseme: [
            { time: 137, type: "viseme", value: "s" },
            { time: 200, type: "viseme", value: "p" },
            { time: 312, type: "viseme", value: "i" },
            { time: 337, type: "viseme", value: "S" },
            { time: 500, type: "viseme", value: "s" },
            { time: 575, type: "viseme", value: "i" },
            { time: 625, type: "viseme", value: "t" },
            { time: 687, type: "viseme", value: "T" },
            { time: 750, type: "viseme", value: "@" },
            { time: 812, type: "viseme", value: "s" },
            { time: 937, type: "viseme", value: "i" },
            { time: 1000, type: "viseme", value: "s" },
            { time: 1137, type: "viseme", value: "sil" },
            { time: 1250, type: "viseme", value: "i" },
            { time: 1312, type: "viseme", value: "s" },
            { time: 1437, type: "viseme", value: "T" },
            { time: 1512, type: "viseme", value: "i" },
            { time: 1562, type: "viseme", value: "a" },
            { time: 1650, type: "viseme", value: "r" },
            { time: 1700, type: "viseme", value: "t" },
            { time: 1750, type: "viseme", value: "@" },
            { time: 1775, type: "viseme", value: "f" },
            { time: 1850, type: "viseme", value: "i" },
            { time: 1875, type: "viseme", value: "S" },
            { time: 1962, type: "viseme", value: "t" },
            { time: 2125, type: "viseme", value: "p" },
            { time: 2137, type: "viseme", value: "r" },
            { time: 2187, type: "viseme", value: "@" },
            { time: 2250, type: "viseme", value: "t" },
            { time: 2312, type: "viseme", value: "E" },
            { time: 2325, type: "viseme", value: "k" },
            { time: 2387, type: "viseme", value: "S" },
            { time: 2462, type: "viseme", value: "t" },
            { time: 2562, type: "viseme", value: "@" },
            { time: 2625, type: "viseme", value: "f" },
            { time: 2637, type: "viseme", value: "k" },
            { time: 2687, type: "viseme", value: "i" },
            { time: 2787, type: "viseme", value: "u" },
            { time: 2825, type: "viseme", value: "p" },
            { time: 2887, type: "viseme", value: "@" },
            { time: 2950, type: "viseme", value: "t" },
            { time: 3000, type: "viseme", value: "s" },
            { time: 3125, type: "viseme", value: "p" },
            { time: 3187, type: "viseme", value: "i" },
            { time: 3312, type: "viseme", value: "S" },
            { time: 3575, type: "viseme", value: "sil" },
            { time: 4105, type: "viseme", value: "@" },
            { time: 4167, type: "viseme", value: "k" },
            { time: 4217, type: "viseme", value: "@" },
            { time: 4280, type: "viseme", value: "p" },
            { time: 4305, type: "viseme", value: "p" },
            { time: 4342, type: "viseme", value: "i" },
            { time: 4417, type: "viseme", value: "u" },
            { time: 4467, type: "viseme", value: "t" },
            { time: 4542, type: "viseme", value: "E" },
            { time: 4592, type: "viseme", value: "s" },
            { time: 4680, type: "viseme", value: "i" },
            { time: 4780, type: "viseme", value: "s" },
            { time: 4842, type: "viseme", value: "t" },
            { time: 4905, type: "viseme", value: "@" },
            { time: 4967, type: "viseme", value: "p" },
            { time: 5030, type: "viseme", value: "i" },
            { time: 5105, type: "viseme", value: "u" },
            { time: 5167, type: "viseme", value: "s" },
            { time: 5230, type: "viseme", value: "t" },
            { time: 5280, type: "viseme", value: "f" },
            { time: 5342, type: "viseme", value: "O" },
            { time: 5355, type: "viseme", value: "r" },
            { time: 5430, type: "viseme", value: "T" },
            { time: 5480, type: "viseme", value: "i" },
            { time: 5530, type: "viseme", value: "s" },
            { time: 5592, type: "viseme", value: "p" },
            { time: 5717, type: "viseme", value: "E" },
            { time: 5805, type: "viseme", value: "p" },
            { time: 5842, type: "viseme", value: "@" },
            { time: 5905, type: "viseme", value: "s" },
            { time: 6005, type: "viseme", value: "i" },
            { time: 6092, type: "viseme", value: "s" },
            { time: 6155, type: "viseme", value: "k" },
            { time: 6230, type: "viseme", value: "O" },
            { time: 6280, type: "viseme", value: "t" },
            { time: 6355, type: "viseme", value: "t" },
            { time: 6417, type: "viseme", value: "@" },
            { time: 6530, type: "viseme", value: "s" },
            { time: 6605, type: "viseme", value: "p" },
            { time: 6655, type: "viseme", value: "i" },
            { time: 6755, type: "viseme", value: "S" },
            { time: 6855, type: "viseme", value: "k" },
            { time: 6917, type: "viseme", value: "@" },
            { time: 6967, type: "viseme", value: "p" },
            { time: 7030, type: "viseme", value: "p" },
            { time: 7092, type: "viseme", value: "i" },
            { time: 7155, type: "viseme", value: "u" },
            { time: 7180, type: "viseme", value: "t" },
            { time: 7280, type: "viseme", value: "E" },
            { time: 7355, type: "viseme", value: "O" },
            { time: 7405, type: "viseme", value: "r" },
            { time: 7542, type: "viseme", value: "s" },
            { time: 7555, type: "viseme", value: "p" },
            { time: 7717, type: "viseme", value: "i" },
            { time: 7855, type: "viseme", value: "S" },
            { time: 7967, type: "viseme", value: "s" },
            { time: 8005, type: "viseme", value: "i" },
            { time: 8092, type: "viseme", value: "t" },
            { time: 8155, type: "viseme", value: "T" },
            { time: 8217, type: "viseme", value: "@" },
            { time: 8255, type: "viseme", value: "s" },
            { time: 8380, type: "viseme", value: "a" },
            { time: 8467, type: "viseme", value: "s" },
            { time: 8555, type: "viseme", value: "E" },
            { time: 8767, type: "viseme", value: "sil" },
            { time: 8780, type: "viseme", value: "a" },
            { time: 9067, type: "viseme", value: "t" },
            { time: 9092, type: "viseme", value: "t" },
            { time: 9117, type: "viseme", value: "k" },
            { time: 9205, type: "viseme", value: "a" },
            { time: 9217, type: "viseme", value: "t" },
            { time: 9280, type: "viseme", value: "p" },
            { time: 9342, type: "viseme", value: "i" },
            { time: 9467, type: "viseme", value: "i" },
            { time: 9530, type: "viseme", value: "p" },
            { time: 9592, type: "viseme", value: "p" },
            { time: 9617, type: "viseme", value: "t" },
            { time: 9667, type: "viseme", value: "@" },
            { time: 9717, type: "viseme", value: "p" },
            { time: 9842, type: "viseme", value: "E" },
            { time: 9867, type: "viseme", value: "t" },
            { time: 9880, type: "viseme", value: "t" },
            { time: 9992, type: "viseme", value: "@" },
            { time: 10005, type: "viseme", value: "t" },
            { time: 10030, type: "viseme", value: "i" },
            { time: 10092, type: "viseme", value: "t" },
            { time: 10217, type: "viseme", value: "s" },
            { time: 10355, type: "viseme", value: "a" },
            { time: 10405, type: "viseme", value: "f" },
            { time: 10467, type: "viseme", value: "t" },
            { time: 10567, type: "viseme", value: "u" },
            { time: 10630, type: "viseme", value: "E" },
            { time: 10655, type: "viseme", value: "r" },
            { time: 10755, type: "viseme", value: "sil" },
            { time: 10967, type: "viseme", value: "O" },
            { time: 11155, type: "viseme", value: "r" },
            { time: 11292, type: "viseme", value: "k" },
            { time: 11355, type: "viseme", value: "a" },
            { time: 11405, type: "viseme", value: "r" },
            { time: 11467, type: "viseme", value: "t" },
            { time: 11517, type: "viseme", value: "u" },
            { time: 11592, type: "viseme", value: "E" },
            { time: 11655, type: "viseme", value: "r" },
            { time: 11717, type: "viseme", value: "p" },
            { time: 11780, type: "viseme", value: "r" },
            { time: 11842, type: "viseme", value: "a" },
            { time: 11930, type: "viseme", value: "t" },
            { time: 11967, type: "viseme", value: "E" },
            { time: 12067, type: "viseme", value: "k" },
            { time: 12117, type: "viseme", value: "s" },
            { time: 12305, type: "viseme", value: "sil" },
          ],
          audioUrl: "audio/female-2.mp3",
        },
      },
      {
        id: 5,
        name: "Feemale 3",
        online: false,
        polly: {
          viseme: [
            { time: 62, type: "viseme", value: "T" },
            { time: 125, type: "viseme", value: "@" },
            { time: 200, type: "viseme", value: "k" },
            { time: 250, type: "viseme", value: "u" },
            { time: 312, type: "viseme", value: "a" },
            { time: 412, type: "viseme", value: "t" },
            { time: 500, type: "viseme", value: "@" },
            { time: 575, type: "viseme", value: "t" },
            { time: 625, type: "viseme", value: "i" },
            { time: 687, type: "viseme", value: "@" },
            { time: 762, type: "viseme", value: "f" },
            { time: 812, type: "viseme", value: "@" },
            { time: 912, type: "viseme", value: "s" },
            { time: 1000, type: "viseme", value: "p" },
            { time: 1062, type: "viseme", value: "i" },
            { time: 1137, type: "viseme", value: "S" },
            { time: 1250, type: "viseme", value: "s" },
            { time: 1312, type: "viseme", value: "i" },
            { time: 1375, type: "viseme", value: "t" },
            { time: 1437, type: "viseme", value: "T" },
            { time: 1512, type: "viseme", value: "@" },
            { time: 1562, type: "viseme", value: "s" },
            { time: 1625, type: "viseme", value: "a" },
            { time: 1762, type: "viseme", value: "s" },
            { time: 1875, type: "viseme", value: "E" },
            { time: 1962, type: "viseme", value: "i" },
            { time: 2037, type: "viseme", value: "s" },
            { time: 2125, type: "viseme", value: "S" },
            { time: 2262, type: "viseme", value: "E" },
            { time: 2325, type: "viseme", value: "S" },
            { time: 2387, type: "viseme", value: "t" },
            { time: 2512, type: "viseme", value: "p" },
            { time: 2562, type: "viseme", value: "a" },
            { time: 2687, type: "viseme", value: "i" },
            { time: 2700, type: "viseme", value: "t" },
            { time: 2750, type: "viseme", value: "s" },
            { time: 2825, type: "viseme", value: "s" },
            { time: 2887, type: "viseme", value: "i" },
            { time: 2950, type: "viseme", value: "p" },
            { time: 3000, type: "viseme", value: "@" },
            { time: 3062, type: "viseme", value: "t" },
            { time: 3125, type: "viseme", value: "a" },
            { time: 3187, type: "viseme", value: "r" },
            { time: 3262, type: "viseme", value: "@" },
            { time: 3312, type: "viseme", value: "t" },
            { time: 3375, type: "viseme", value: "i" },
            { time: 3487, type: "viseme", value: "t" },
            { time: 3500, type: "viseme", value: "u" },
            { time: 3587, type: "viseme", value: "T" },
            { time: 3625, type: "viseme", value: "@" },
            { time: 3712, type: "viseme", value: "k" },
            { time: 3750, type: "viseme", value: "i" },
            { time: 3825, type: "viseme", value: "u" },
            { time: 3887, type: "viseme", value: "p" },
            { time: 3950, type: "viseme", value: "@" },
            { time: 4000, type: "viseme", value: "t" },
            { time: 4062, type: "viseme", value: "f" },
            { time: 4187, type: "viseme", value: "O" },
            { time: 4250, type: "viseme", value: "s" },
            { time: 4500, type: "viseme", value: "sil" },
            { time: 4587, type: "viseme", value: "a" },
            { time: 4750, type: "viseme", value: "t" },
            { time: 4800, type: "viseme", value: "t" },
            { time: 4875, type: "viseme", value: "p" },
            { time: 4937, type: "viseme", value: "a" },
            { time: 5062, type: "viseme", value: "i" },
            { time: 5075, type: "viseme", value: "t" },
            { time: 5125, type: "viseme", value: "s" },
            { time: 5150, type: "viseme", value: "@" },
            { time: 5250, type: "viseme", value: "p" },
            { time: 5312, type: "viseme", value: "i" },
            { time: 5375, type: "viseme", value: "t" },
            { time: 5462, type: "viseme", value: "@" },
            { time: 5500, type: "viseme", value: "t" },
            { time: 5562, type: "viseme", value: "i" },
            { time: 5625, type: "viseme", value: "t" },
            { time: 5687, type: "viseme", value: "u" },
            { time: 5750, type: "viseme", value: "p" },
            { time: 5812, type: "viseme", value: "i" },
            { time: 5900, type: "viseme", value: "E" },
            { time: 5937, type: "viseme", value: "t" },
            { time: 6025, type: "viseme", value: "t" },
            { time: 6062, type: "viseme", value: "E" },
            { time: 6125, type: "viseme", value: "s" },
            { time: 6200, type: "viseme", value: "t" },
            { time: 6250, type: "viseme", value: "u" },
            { time: 6312, type: "viseme", value: "t" },
            { time: 6400, type: "viseme", value: "k" },
            { time: 6437, type: "viseme", value: "t" },
            { time: 6500, type: "viseme", value: "i" },
            { time: 6625, type: "viseme", value: "r" },
            { time: 6687, type: "viseme", value: "t" },
            { time: 6762, type: "viseme", value: "i" },
            { time: 7012, type: "viseme", value: "sil" },
          ],
          audioUrl: "audio/female-3.mp3",
        },
      },
      {
        id: 6,
        name: "Feemale 7",
        online: false,
        polly: {
          viseme: [
            { time: 100, type: "viseme", value: "t" },
            { time: 187, type: "viseme", value: "i" },
            { time: 200, type: "viseme", value: "S" },
            { time: 250, type: "viseme", value: "i" },
            { time: 350, type: "viseme", value: "t" },
            { time: 375, type: "viseme", value: "t" },
            { time: 450, type: "viseme", value: "k" },
            { time: 500, type: "viseme", value: "i" },
            { time: 637, type: "viseme", value: "u" },
            { time: 650, type: "viseme", value: "p" },
            { time: 762, type: "viseme", value: "@" },
            { time: 812, type: "viseme", value: "t" },
            { time: 825, type: "viseme", value: "s" },
            { time: 937, type: "viseme", value: "t" },
            { time: 1000, type: "viseme", value: "i" },
            { time: 1087, type: "viseme", value: "f" },
            { time: 1187, type: "viseme", value: "i" },
            { time: 1200, type: "viseme", value: "t" },
            { time: 1250, type: "viseme", value: "T" },
            { time: 1312, type: "viseme", value: "@" },
            { time: 1325, type: "viseme", value: "p" },
            { time: 1375, type: "viseme", value: "E" },
            { time: 1437, type: "viseme", value: "t" },
            { time: 1487, type: "viseme", value: "@" },
            { time: 1562, type: "viseme", value: "f" },
            { time: 1625, type: "viseme", value: "E" },
            { time: 1750, type: "viseme", value: "s" },
            { time: 1875, type: "viseme", value: "sil" },
            { time: 1962, type: "viseme", value: "u" },
            { time: 2225, type: "viseme", value: "E" },
            { time: 2262, type: "viseme", value: "r" },
            { time: 2312, type: "viseme", value: "T" },
            { time: 2375, type: "viseme", value: "e" },
            { time: 2462, type: "viseme", value: "f" },
            { time: 2550, type: "viseme", value: "E" },
            { time: 2637, type: "viseme", value: "k" },
            { time: 2687, type: "viseme", value: "k" },
            { time: 2712, type: "viseme", value: "S" },
            { time: 2787, type: "viseme", value: "t" },
            { time: 2887, type: "viseme", value: "t" },
            { time: 2950, type: "viseme", value: "a" },
            { time: 3000, type: "viseme", value: "t" },
            { time: 3125, type: "viseme", value: "a" },
            { time: 3137, type: "viseme", value: "s" },
            { time: 3250, type: "viseme", value: "r" },
            { time: 3312, type: "viseme", value: "E" },
            { time: 3375, type: "viseme", value: "p" },
            { time: 3387, type: "viseme", value: "t" },
            { time: 3487, type: "viseme", value: "i" },
            { time: 3500, type: "viseme", value: "k" },
            { time: 3575, type: "viseme", value: "@" },
            { time: 3637, type: "viseme", value: "s" },
            { time: 3737, type: "viseme", value: "@" },
            { time: 3750, type: "viseme", value: "f" },
            { time: 3887, type: "viseme", value: "r" },
            { time: 3912, type: "viseme", value: "i" },
            { time: 3950, type: "viseme", value: "@" },
            { time: 4000, type: "viseme", value: "t" },
            { time: 4062, type: "viseme", value: "p" },
            { time: 4187, type: "viseme", value: "i" },
            { time: 4250, type: "viseme", value: "p" },
            { time: 4287, type: "viseme", value: "@" },
            { time: 4362, type: "viseme", value: "t" },
            { time: 4500, type: "viseme", value: "sil" },
            { time: 4562, type: "viseme", value: "p" },
            { time: 4800, type: "viseme", value: "@" },
            { time: 4812, type: "viseme", value: "t" },
            { time: 4875, type: "viseme", value: "a" },
            { time: 4937, type: "viseme", value: "s" },
            { time: 5075, type: "viseme", value: "e" },
            { time: 5262, type: "viseme", value: "a" },
            { time: 5462, type: "viseme", value: "p" },
            { time: 5500, type: "viseme", value: "a" },
            { time: 5625, type: "viseme", value: "k" },
            { time: 5650, type: "viseme", value: "t" },
            { time: 5750, type: "viseme", value: "t" },
            { time: 5875, type: "viseme", value: "a" },
            { time: 5900, type: "viseme", value: "t" },
            { time: 5937, type: "viseme", value: "p" },
            { time: 6025, type: "viseme", value: "t" },
            { time: 6062, type: "viseme", value: "e" },
            { time: 6125, type: "viseme", value: "i" },
            { time: 6212, type: "viseme", value: "k" },
            { time: 6262, type: "viseme", value: "k" },
            { time: 6400, type: "viseme", value: "a" },
            { time: 6437, type: "viseme", value: "r" },
            { time: 6500, type: "viseme", value: "@" },
            { time: 6562, type: "viseme", value: "k" },
            { time: 6625, type: "viseme", value: "t" },
            { time: 6687, type: "viseme", value: "E" },
            { time: 6762, type: "viseme", value: "s" },
            { time: 6875, type: "viseme", value: "sil" },
            { time: 7075, type: "viseme", value: "k" },
            { time: 7325, type: "viseme", value: "u" },
            { time: 7387, type: "viseme", value: "sil" },
            { time: 7700, type: "viseme", value: "E" },
            { time: 7812, type: "viseme", value: "t" },
            { time: 7875, type: "viseme", value: "t" },
            { time: 7987, type: "viseme", value: "a" },
            { time: 8000, type: "viseme", value: "k" },
            { time: 8100, type: "viseme", value: "T" },
            { time: 8125, type: "viseme", value: "E" },
            { time: 8150, type: "viseme", value: "r" },
            { time: 8300, type: "viseme", value: "f" },
            { time: 8337, type: "viseme", value: "i" },
            { time: 8375, type: "viseme", value: "t" },
            { time: 8437, type: "viseme", value: "i" },
            { time: 8500, type: "viseme", value: "o" },
            { time: 8637, type: "viseme", value: "k" },
            { time: 8712, type: "viseme", value: "e" },
            { time: 8775, type: "viseme", value: "p" },
            { time: 8875, type: "viseme", value: "k" },
            { time: 8950, type: "viseme", value: "a" },
            { time: 9000, type: "viseme", value: "t" },
            { time: 9062, type: "viseme", value: "t" },
            { time: 9137, type: "viseme", value: "E" },
            { time: 9200, type: "viseme", value: "p" },
            { time: 9275, type: "viseme", value: "a" },
            { time: 9350, type: "viseme", value: "r" },
            { time: 9375, type: "viseme", value: "t" },
            { time: 9437, type: "viseme", value: "s" },
            { time: 9500, type: "viseme", value: "sil" },
            { time: 9675, type: "viseme", value: "k" },
            { time: 9875, type: "viseme", value: "a" },
            { time: 9937, type: "viseme", value: "t" },
            { time: 10000, type: "viseme", value: "r" },
            { time: 10062, type: "viseme", value: "i" },
            { time: 10187, type: "viseme", value: "a" },
            { time: 10287, type: "viseme", value: "k" },
            { time: 10325, type: "viseme", value: "t" },
            { time: 10437, type: "viseme", value: "i" },
            { time: 10500, type: "viseme", value: "t" },
            { time: 10562, type: "viseme", value: "t" },
            { time: 10625, type: "viseme", value: "E" },
            { time: 10712, type: "viseme", value: "t" },
            { time: 10737, type: "viseme", value: "@" },
            { time: 10825, type: "viseme", value: "S" },
            { time: 10912, type: "viseme", value: "@" },
            { time: 10950, type: "viseme", value: "t" },
            { time: 11012, type: "viseme", value: "t" },
            { time: 11025, type: "viseme", value: "t" },
            { time: 11062, type: "viseme", value: "i" },
            { time: 11162, type: "viseme", value: "t" },
            { time: 11187, type: "viseme", value: "u" },
            { time: 11250, type: "viseme", value: "i" },
            { time: 11325, type: "viseme", value: "E" },
            { time: 11437, type: "viseme", value: "i" },
            { time: 11562, type: "viseme", value: "t" },
            { time: 11587, type: "viseme", value: "p" },
            { time: 11725, type: "viseme", value: "u" },
            { time: 11750, type: "viseme", value: "t" },
            { time: 12025, type: "viseme", value: "sil" },
          ],
          audioUrl: "audio/female-7.mp3",
        },
      },
      {
        id: 7,
        name: "Feemale 8",
        online: false,
        polly: {
          viseme: [
            { time: 125, type: "viseme", value: "a" },
            { time: 187, type: "viseme", value: "p" },
            { time: 250, type: "viseme", value: "t" },
            { time: 312, type: "viseme", value: "r" },
            { time: 387, type: "viseme", value: "a" },
            { time: 450, type: "viseme", value: "i" },
            { time: 500, type: "viseme", value: "k" },
            { time: 575, type: "viseme", value: "t" },
            { time: 600, type: "viseme", value: "u" },
            { time: 625, type: "viseme", value: "k" },
            { time: 687, type: "viseme", value: "E" },
            { time: 712, type: "viseme", value: "t" },
            { time: 750, type: "viseme", value: "p" },
            { time: 937, type: "viseme", value: "i" },
            { time: 1000, type: "viseme", value: "u" },
            { time: 1137, type: "viseme", value: "sil" },
            { time: 1250, type: "viseme", value: "p" },
            { time: 1375, type: "viseme", value: "@" },
            { time: 1400, type: "viseme", value: "t" },
            { time: 1487, type: "viseme", value: "a" },
            { time: 1562, type: "viseme", value: "p" },
            { time: 1587, type: "viseme", value: "t" },
            { time: 1625, type: "viseme", value: "a" },
            { time: 1712, type: "viseme", value: "t" },
            { time: 1837, type: "viseme", value: "S" },
            { time: 1875, type: "viseme", value: "u" },
            { time: 1937, type: "viseme", value: "r" },
            { time: 2037, type: "viseme", value: "u" },
            { time: 2125, type: "viseme", value: "E" },
            { time: 2162, type: "viseme", value: "t" },
            { time: 2187, type: "viseme", value: "i" },
            { time: 2262, type: "viseme", value: "u" },
            { time: 2312, type: "viseme", value: "t" },
            { time: 2387, type: "viseme", value: "i" },
            { time: 2425, type: "viseme", value: "t" },
            { time: 2537, type: "viseme", value: "f" },
            { time: 2562, type: "viseme", value: "r" },
            { time: 2625, type: "viseme", value: "@" },
            { time: 2650, type: "viseme", value: "p" },
            { time: 2687, type: "viseme", value: "p" },
            { time: 2750, type: "viseme", value: "i" },
            { time: 2962, type: "viseme", value: "sil" },
          ],
          audioUrl: "audio/female-8.mp3",
        },
      },
      {
        id: 8,
        name: "One",
        online: true,
        polly: {
          viseme: [
            {
              time: 137,
              type: "viseme",
              value: "k",
            },
            {
              time: 300,
              type: "viseme",
              value: "a",
            },
            {
              time: 500,
              type: "viseme",
              value: "sil",
            },
            {
              time: 625,
              type: "viseme",
              value: "t",
            },
            {
              time: 1037,
              type: "viseme",
              value: "a",
            },
            {
              time: 1137,
              type: "viseme",
              value: "s",
            },
            {
              time: 1250,
              type: "viseme",
              value: "t",
            },
            {
              time: 1312,
              type: "viseme",
              value: "@",
            },
            {
              time: 1437,
              type: "viseme",
              value: "p",
            },
            {
              time: 1487,
              type: "viseme",
              value: "i",
            },
            {
              time: 1625,
              type: "viseme",
              value: "t",
            },
            {
              time: 1762,
              type: "viseme",
              value: "i",
            },
            {
              time: 1875,
              type: "viseme",
              value: "u",
            },
            {
              time: 2262,
              type: "viseme",
              value: "sil",
            },
            {
              time: 2817,
              type: "viseme",
              value: "p",
            },
            {
              time: 2917,
              type: "viseme",
              value: "a",
            },
            {
              time: 3055,
              type: "viseme",
              value: "t",
            },
            {
              time: 3180,
              type: "viseme",
              value: "e",
            },
            {
              time: 3242,
              type: "viseme",
              value: "p",
            },
            {
              time: 3430,
              type: "viseme",
              value: "i",
            },
            {
              time: 3517,
              type: "viseme",
              value: "s",
            },
            {
              time: 3742,
              type: "viseme",
              value: "E",
            },
            {
              time: 3830,
              type: "viseme",
              value: "t",
            },
            {
              time: 3930,
              type: "viseme",
              value: "i",
            },
            {
              time: 4055,
              type: "viseme",
              value: "@",
            },
            {
              time: 4167,
              type: "viseme",
              value: "t",
            },
            {
              time: 4355,
              type: "viseme",
              value: "sil",
            },
          ],
          audioUrl:
            "https://s3.eu-west-1.amazonaws.com/voxly.demos/assets/avatar/speech.mp3",
        },
      },
      {
        id: 9,
        name: "Two",
        online: false,
        polly: {
          viseme: [
            { time: 50, type: "viseme", value: "u" },
            { time: 187, type: "viseme", value: "E" },
            { time: 200, type: "viseme", value: "t" },
            { time: 250, type: "viseme", value: "k" },
            { time: 312, type: "viseme", value: "@" },
            { time: 375, type: "viseme", value: "p" },
            { time: 450, type: "viseme", value: "t" },
            { time: 500, type: "viseme", value: "@" },
            { time: 562, type: "viseme", value: "p" },
            { time: 625, type: "viseme", value: "a" },
            { time: 712, type: "viseme", value: "t" },
            { time: 812, type: "viseme", value: "E" },
            { time: 887, type: "viseme", value: "p" },
            { time: 937, type: "viseme", value: "@" },
            { time: 1062, type: "viseme", value: "a" },
            { time: 1137, type: "viseme", value: "p" },
            { time: 1200, type: "viseme", value: "t" },
            { time: 1250, type: "viseme", value: "i" },
            { time: 1312, type: "viseme", value: "k" },
            { time: 1375, type: "viseme", value: "e" },
            { time: 1487, type: "viseme", value: "S" },
            { time: 1625, type: "viseme", value: "t" },
            { time: 1750, type: "viseme", value: "sil" },
            { time: 2242, type: "viseme", value: "i" },
            { time: 2417, type: "viseme", value: "t" },
            { time: 2430, type: "viseme", value: "s" },
            { time: 2480, type: "viseme", value: "s" },
            { time: 2542, type: "viseme", value: "@" },
            { time: 2680, type: "viseme", value: "k" },
            { time: 2730, type: "viseme", value: "u" },
            { time: 2805, type: "viseme", value: "t" },
            { time: 2855, type: "viseme", value: "t" },
            { time: 2867, type: "viseme", value: "@" },
            { time: 2942, type: "viseme", value: "s" },
            { time: 2980, type: "viseme", value: "i" },
            { time: 3167, type: "viseme", value: "i" },
            { time: 3230, type: "viseme", value: "u" },
            { time: 3292, type: "viseme", value: "@" },
            { time: 3355, type: "viseme", value: "k" },
            { time: 3380, type: "viseme", value: "E" },
            { time: 3542, type: "viseme", value: "t" },
            { time: 3667, type: "viseme", value: "sil" },
            { time: 4110, type: "viseme", value: "t" },
            { time: 4285, type: "viseme", value: "@" },
            { time: 4297, type: "viseme", value: "t" },
            { time: 4347, type: "viseme", value: "e" },
            { time: 4535, type: "viseme", value: "u" },
            { time: 4597, type: "viseme", value: "i" },
            { time: 4672, type: "viseme", value: "a" },
            { time: 4735, type: "viseme", value: "k" },
            { time: 4785, type: "viseme", value: "@" },
            { time: 4860, type: "viseme", value: "i" },
            { time: 4910, type: "viseme", value: "k" },
            { time: 4935, type: "viseme", value: "t" },
            { time: 4972, type: "viseme", value: "@" },
            { time: 5035, type: "viseme", value: "t" },
            { time: 5097, type: "viseme", value: "O" },
            { time: 5235, type: "viseme", value: "k" },
            { time: 5297, type: "viseme", value: "@" },
            { time: 5347, type: "viseme", value: "p" },
            { time: 5410, type: "viseme", value: "a" },
            { time: 5472, type: "viseme", value: "t" },
            { time: 5585, type: "viseme", value: "t" },
            { time: 5610, type: "viseme", value: "i" },
            { time: 5660, type: "viseme", value: "S" },
            { time: 5722, type: "viseme", value: "i" },
            { time: 5735, type: "viseme", value: "t" },
            { time: 5847, type: "viseme", value: "t" },
            { time: 5947, type: "viseme", value: "k" },
            { time: 5972, type: "viseme", value: "i" },
            { time: 6035, type: "viseme", value: "u" },
            { time: 6122, type: "viseme", value: "p" },
            { time: 6185, type: "viseme", value: "@" },
            { time: 6222, type: "viseme", value: "t" },
            { time: 6285, type: "viseme", value: "s" },
            { time: 6372, type: "viseme", value: "sil" },
          ],
          audioUrl: "audio/speech-2.mp3",
        },
      },
    ],
    toggleIdle: () => set((state) => ({ idle: !state.idle })),
    increasePlay: () => set((state) => ({ play: state.play + 1 })),
    setCanPlay: (canPlay) => set((state) => ({ canPlay: canPlay })),
    
    setCurrentPolly: (newPolly) =>
      set((state) => {
        return { currentPolly: newPolly };
      }),
    //   removeAllBears: () => set({ bears: 0 }),
  }))
);

export default useStore;
